import React from "react";
import PropTypes from 'prop-types';

const styles = {
  infoTile: {
    width: 160,
    height: 110,
    backgroundColor: '#37AAB4',
    textAlign: 'center',
    borderRadius: 10,
    textOverflow: 'ellipsis',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    color: '#FFFFFF',
    padding: 2,
    fontSize: 22,
    width: 136,
    height: 36,
  },
  data: {
    backgroundColor: '#FFFFFF',
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 140,
    height: 64,
    fontWeight: 600,
  },
  deviceOffline: {
    fontSize: 24,
    lineHeight: '24px',
    color: '#D22D3c',
  },
  deviceOnline: {
    color: '#37AAB4',
    fontSize: 36,
    textOverflow: 'ellipsis',
  },
}
class InfoTile extends React.PureComponent {
  render() {
    const { title, data, deviceOffline } = this.props;
    return(
      <div
        className={'component-infoTile'}
        style={styles.infoTile}
      >
        <div
          style={styles.title}
        >
          {title}
        </div>
        <div
          style={{
            ...styles.data,
            ...(deviceOffline ? styles.deviceOffline : styles.deviceOnline),
          }}
          dangerouslySetInnerHTML={{__html: data}}
        >
        </div>
      </div>
    )
  }
}

InfoTile.defaultProps = {
  deviceOffline: false,
};

InfoTile.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  deviceOffline: PropTypes.bool,
};

export default InfoTile;
